import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#22336c',      // deep blue
      light: '#4159a0',
      dark: '#101a3a',
    },
    secondary: {
      main: '#d4af37',      // gold
      light: '#ffe082',
      dark: '#b8860b',
    },
    background: {
      default: '#f8f5ec',   // parchment-like
      paper: '#fffdfa',     // lighter parchment
    },
    text: {
      primary: '#22336c',
      secondary: '#6b5e3c', // warm brown
    },
  },
  typography: {
    fontFamily: '"Merriweather", "Inter", "Roboto", "Helvetica", "Arial", serif',
    h1: {
      fontSize: '3.5rem',
      fontWeight: 700,
      lineHeight: 1.2,
      letterSpacing: '-0.02em',
      fontFamily: '"Merriweather", serif',
      '@media (max-width:600px)': {
        fontSize: '2.2rem',
      },
    },
    h2: {
      fontSize: '2.5rem',
      fontWeight: 600,
      lineHeight: 1.3,
      letterSpacing: '-0.01em',
      fontFamily: '"Merriweather", serif',
      '@media (max-width:600px)': {
        fontSize: '1.7rem',
      },
    },
    h3: {
      fontSize: '2rem',
      fontWeight: 600,
      lineHeight: 1.4,
      fontFamily: '"Merriweather", serif',
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 500,
      lineHeight: 1.4,
      fontFamily: '"Merriweather", serif',
    },
    body1: {
      fontSize: '1.125rem',
      lineHeight: 1.6,
      color: '#6b5e3c',
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
      fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          padding: '12px 32px',
          fontSize: '1rem',
          fontWeight: 500,
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(34,51,108,0.15)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 3px rgba(34,51,108,0.12), 0 1px 2px rgba(34,51,108,0.18)',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(212,175,55,0.15)',
          },
        },
      },
    },
  },
});

export default theme;
